/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CardsHumansFilter = {
    /**
     * Select only active (`true`) or disabled (`false`) cards
     */
    active?: boolean;
    /**
     * Select objects with `created_date` **greater** than this value
     */
    created_date_gt?: string;
    /**
     * Select objects with `created_date` **greater than or equal** to this value
     */
    created_date_gte?: string;
    /**
     * Select objects with `created_date` in last N days
     */
    created_date_last_n_days?: number;
    /**
     * Select objects with `created_date` **less** than this value
     */
    created_date_lt?: string;
    /**
     * Select objects with `created_date` **less than or equal** to this value
     */
    created_date_lte?: string;
    /**
     * Select objects with `created_date` in last Nth week (including Sunday and Saturday)
     */
    created_date_nth_full_week?: number;
    /**
     * Select objects with `created_date` in last Nth week (only working days, i.e. excluding Sunday and Saturday)
     */
    created_date_nth_work_week?: number;
    /**
     * Select only cards with linked body objects (`true`) or without them (`false`)
     */
    has_body_objects?: string;
    /**
     * Select only cards with linked face objects (`true`) or without them (`false`)
     */
    has_face_objects?: string;
    /**
     * Select cards with provided ids
     */
    id_in?: Array<number>;
    /**
     * Number of results to return per page.
     */
    limit?: string;
    /**
     * Select cards that contain object similar to: (`detection:<detection id>`, `{face, body, or car}event:<event id>` `{face, body, or car}object:<object id>`, `{face, body or car}cluster:<cluster id>` or `casecluster:<casecluster id>`)
     */
    looks_like?: string;
    /**
     * Select objects with `modified_date` **greater** than this value
     */
    modified_date_date_gt?: string;
    /**
     * Select objects with `modified_date` **greater than or equal** to this value
     */
    modified_date_date_gte?: string;
    /**
     * Select objects with `modified_date` **less** than this value
     */
    modified_date_date_lt?: string;
    /**
     * Select objects with `modified_date` **less than or equal** to this value
     */
    modified_date_date_lte?: string;
    /**
     * Select objects that were modified in last N days
     */
    modified_date_last_n_days?: number;
    /**
     * Select objects that were modified in last Nth week (including Sunday and Saturday)
     */
    modified_date_nth_full_week?: number;
    /**
     * Select objects that were modified in last Nth week (only working days, i.e. excluding Sunday and Saturday)
     */
    modified_date_nth_work_week?: number;
    /**
     * Select cards where the SQL condition `name ILIKE name_contains` is true
     */
    name_contains?: string;
    /**
     * Which field to use when ordering the results. Available fields: `created_date`, `id`, `looks_like_confidence`
     */
    ordering?: string;
    /**
     * Pagination cursor value.
     */
    page?: string;
    /**
     * Similarity threshold for `looks_like`
     */
    threshold?: number;
    /**
     * Select cards included in these watch lists
     */
    watch_lists?: Array<number>;
}
export const EmptyCardsHumansFilter: CardsHumansFilter = {
    active: undefined,
    created_date_gt: undefined,
    created_date_gte: undefined,
    created_date_last_n_days: undefined,
    created_date_lt: undefined,
    created_date_lte: undefined,
    created_date_nth_full_week: undefined,
    created_date_nth_work_week: undefined,
    has_body_objects: undefined,
    has_face_objects: undefined,
    id_in: [],
    limit: '20',
    looks_like: undefined,
    modified_date_date_gt: undefined,
    modified_date_date_gte: undefined,
    modified_date_date_lt: undefined,
    modified_date_date_lte: undefined,
    modified_date_last_n_days: undefined,
    modified_date_nth_full_week: undefined,
    modified_date_nth_work_week: undefined,
    name_contains: undefined,
    ordering: '-id',
    page: undefined,
    threshold: undefined,
    watch_lists: [],
}